export default __webpack_public_path__ + "static/media/config-department-illustration.3183f75f.svg";